import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectSuggestForPurchaseTransactions } from 'app/selectors/SuggestForPurchaseSelector';
import {
  userIdentityShape,
  catalogBibShape,
  accountShape,
  branchShape,
  libraryShape
} from '@bibliocommons/bc-prop-types';
import { selectCurrentUser, selectCurrentAccount } from 'app/selectors/AuthSelector';
import ModalActions from 'app/actions/ModalActions';
import SuggestForPurchaseActions from 'app/actions/SuggestForPurchaseActions';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import {
  selectPickupBranches,
  selectActivePreferredBranches,
  selectCurrentLibrary
} from 'app/selectors/LibrarySelector';
import LiteSuggestionButton from './LiteSuggestionButton';

export function LiteSuggestionButtonContainer(props) {
  return <LiteSuggestionButton {...props} />;
}

LiteSuggestionButtonContainer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  currentAccount: accountShape,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  suggestForPurchaseActions: PropTypes.objectOf(PropTypes.func).isRequired,
  suggestForPurchaseTransactions: ImmutablePropTypes.map.isRequired,
  currentUser: userIdentityShape,
  catalogBib: catalogBibShape.isRequired
};

const mapStateToProps = state => ({
  currentLibrary: selectCurrentLibrary(state),
  branches: selectPickupBranches(state),
  preferredBranches: selectActivePreferredBranches(state),
  currentAccount: selectCurrentAccount(state),
  suggestForPurchaseTransactions: selectSuggestForPurchaseTransactions(state),
  currentUser: selectCurrentUser(state),
  catalogBib: selectCatalogBib(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch),
  suggestForPurchaseActions: bindActionCreators(SuggestForPurchaseActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LiteSuggestionButtonContainer);
